<template>
  <div
    v-if="!isTopbarHidden"
    class="topbar c:row-center"
    :class="{ top: isTopbarTop }"
  >
    <div class="header-logo-container logo c:row-center">
      <img :src="brandInfo.logo" alt="" width="100%" />
    </div>
    <a
      v-if="isStoreSwitchVisible"
      href="javascript:;"
      @click.prevent="onSelectStore"
      class="switch"
    >
      <span>{{ currentStore?.storeName }}</span>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["brandInfo"]),
    ...mapGetters(["currentStore"]),
    isTopbarHidden() {
      return !!this.$route.meta?.topbarHidden;
    },
    isTopbarTop() {
      console.log(this.$route.name);
      return ["SAOrders", "StoreManagerOrders", "AreaManagerOrders"].includes(
        this.$route.name
      );
    },
    isStoreSwitchVisible() {
      console.log("isStoreSwitchVisible", this.$route.meta);
      return (
        this.$store.getters.canSwitchStore && this.$route.meta?.storeSelectable
      );
    },
  },
  methods: {
    onSelectStore() {
      this.$router.push({
        name: "SelectStore",
        query: {
          from: encodeURIComponent(this.$route.path),
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.topbar {
  box-sizing: border-box;
  width: 100vw;
  height: var(--layout-header-height);
  background: #fff;
  z-index: 0;
  &.top {
    z-index: 5000;
  }
}
.header-logo-container {
  width: 100%;
  height: 100%;
}
.logo {
  width: 100%;
  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}

.switch {
  position: absolute;
  box-sizing: border-box;
  width: 80/20rem;
  height: 27/20rem;
  right: 20/20rem;
  padding: 6/20rem 5/20rem 6/20rem 22/20rem;
  border-radius: 14/20rem;
  background: #f0f0f0 url("../../assets/icons/switch.svg");
  background-position: 5/20rem center;
  background-size: 12/20rem auto;
  background-repeat: no-repeat;

  line-height: 15/20rem;
  font-size: 11/20rem;
  color: #5e5e5e;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  z-index: 400;
}
</style>
